import React from 'react';
const pains = [{
  emoji: '😰',
  title: 'Ständige Kursplanung von Null',
  description: 'Jede Woche verbringen Sie Stunden damit, Trainingspläne zu erstellen, Übungen zu recherchieren, Stundenstrukturen aufzubauen und Einheiten für Kunden mit unterschiedlichen Levels, Zielen und Equipment anzupassen.'
}, {
  emoji: '⚠️',
  title: 'Unsicherheit über Progression und Struktur',
  description: 'Sie fragen sich ständig, ob Ihre Kunden bereit sind, die Intensität zu steigern – oder ob ein zu schnelles Voranschreiten ohne die richtigen Progressionstools zu Verletzungen oder mangelnder Motivation führen könnte.'
}, {
  emoji: '📚',
  title: 'Informationen überall verstreut',
  description: 'Übungsdatenbanken, Trainingsvorlagen, Progressionsmodelle, Tracking-Sheets – alles existiert, aber verstreut über YouTube, Kurse, PDFs und unzählige Ordner. Nichts ist in einem System organisiert, das Sie täglich nutzen können.'
}, {
  emoji: '😩',
  title: 'Mentale Erschöpfung',
  description: 'Zwischen Kundenbetreuung, Planung, Programmierung, Dokumentation und täglichem Organisationsaufwand bleibt kaum Zeit für das, was wirklich zählt: präsent für Ihre Kunden zu sein und sie weiterzubringen.'
}];
export function PainSection() {
  return <section className="py-10 px-4 bg-white border-y border-brand-gold/30" data-id="element-108">
      <div className="max-w-4xl mx-auto" data-id="element-109">
        <h2 className="text-2xl sm:text-4xl font-serif font-bold text-center text-brand-graphite mb-3" data-id="element-110">
          KOMMT IHNEN DAS BEKANNT VOR?
        </h2>

        <p className="text-base sm:text-lg text-brand-graphite/80 text-center mb-6 max-w-3xl mx-auto" data-id="element-111">
          Sie lieben es zu trainieren und Ihre Kunden zu coachen – aber die
          Kursplanung verschlingt Ihre gesamte Woche. Als Functional Trainer,
          Personal Trainer oder Studio-Inhaber kennen Sie sicher eine dieser
          Situationen:
        </p>

        <div className="grid sm:grid-cols-2 gap-4" data-id="element-112">
          {pains.map((pain, i) => <div key={i} className="bg-brand-cream p-4 sm:p-5 rounded-lg border border-brand-petrol/20" data-id="element-113">
              <div className="text-3xl mb-2" data-id="element-114">{pain.emoji}</div>
              <h3 className="text-lg font-bold text-brand-petrol mb-1.5" data-id="element-115">
                {pain.title}
              </h3>
              <p className="text-brand-graphite/80 text-sm leading-relaxed" data-id="element-116">
                {pain.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}